import styled from "styled-components";
import zIndexTypes from "../../../theme/zIndexTypes";
import {
  mediaMaxWidth,
  mediaMaxHeight,
} from "../../../theme/mediaQueriesTemplates";

export const RejectWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  z-index: ${zIndexTypes.modal};
  width: 100vw;
  background: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const Modal = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 800px;
  border-radius: 8px;
  padding: 10px 20px;
  margin-left: 60px;
  position: relative;

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
    width: calc(100vw - 30px);
  }

  ${mediaMaxWidth.tablet} {
    position: absolute;
    top: 10px;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    padding: 10px 10px;
  }

  ${mediaMaxHeight.phone} {
    top: 10px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
`;

export const Form = styled.form`
  width: 500px;
  margin: 0 auto;

  ${mediaMaxWidth.tablet} {
    width: 400px;
  }

  ${mediaMaxWidth.phone} {
    width: 85vw;
  }
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;

  span {
    font-weight: 700;
  }
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  width: 100%;
  resize: none;
  height: 10em;
  padding: 10px;
  position: relative;
  margin: 30px 0;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px 10px;
  }
`;

export const Field = styled.div`
  position: relative;
`;

export const Error = styled.div`
  position: absolute;
  bottom: -25px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 600;
`;
